var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Button } from "./index";
import { Label2 } from "../Text";
import { ButtonVariants } from "../../theme/enums";
export const ActionableTag = (_a) => {
    var { children, onClick, variant = ButtonVariants.actionableTagPrimary } = _a, props = __rest(_a, ["children", "onClick", "variant"]);
    return (_jsxs(Button, Object.assign({ onClick: onClick, variant: variant }, props, { children: [_jsx(Label2, { children: children }), _jsx("i", { sx: {
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    width: 16,
                    height: "100%"
                }, children: _jsxs("svg", { width: "7", height: "6", viewBox: "0 0 7 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", sx: { width: 7, height: 6, marginLeft: 5 }, children: [_jsx("path", { d: "M7 6L4.28151 3L7 0L5.71849 0L3 3L5.71849 6H7Z", fill: "currentcolor" }), _jsx("path", { d: "M7.75312e-07 0L2.71849 3L0 6H1.28151L4 3L1.28151 0H7.75312e-07Z", fill: "currentcolor" })] }) })] })));
};
export default ActionableTag;
//# sourceMappingURL=ActionableTag.js.map